import React from 'react'
import MainHeader from "./partials/newheader";    
import Events from './Events';
import Footer from "./partials/footer";


export default function Pettipettievent() {
  return (
    <div>
      <MainHeader />
      <Events />
      <Footer />
    </div>
  );
}
